import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { SafeUrlPipe } from '../../shared/pipes/safe-url.pipe';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'sibat-full-screen-picture',
  template: `
    <div class="full-screen-elem">
      <button mat-icon-button class="close-button" (click)="closeDialog()" matTooltip="{{ 'layout.closeDialog' | transloco }}">
        <mat-icon class="close-icon" color="warn">close</mat-icon>
      </button>
      <img [src]="pictureData | safeUrl" alt="" />
    </div>
  `,
  styleUrls: ['full-screen-picture.component.scss'],
  imports: [MatIconButton, MatTooltip, MatIcon, SafeUrlPipe, TranslocoPipe],
})
export class FullScreenPictureComponent {
  constructor(
    @Optional() public dialogRef: MatDialogRef<FullScreenPictureComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public pictureData: string
  ) {}

  closeDialog(): void {
    this.dialogRef.close();
  }
}
